import { Route, Routes } from "react-router-dom";

import LoadingPage from "components/LoadingPage";
import useRoutersLandingPage from "hooks/useRoutersLandingPage";
import useRoutersLojas from "hooks/useRoutersLojas";
import useRoutersMarketing from "hooks/useRoutersMarketing";
import useRoutersSistemas from "hooks/useRoutersSistemas";
import useRoutersSiteInstitucional from "hooks/useRoutersSiteInstitucional";
import useRoutersSitePortfolio from "hooks/useRoutersSitePortfolio";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
import { lazy, Suspense } from "react";
import ManutencaoEvolucao from "pages/Sites/ManutencaoEvolucao";

const SobreNos = lazy(() => import("pages/SobreNos"));
const TermosDeUso = lazy(() => import("pages/TermosUso"));
const PoliticaDePrivacidade = lazy(() => import("pages/PoliticaPrivacidade"));
const Agendar = lazy(() => import("pages/Agendar"));

function Router() {
  const landingPageRoutes = useRoutersLandingPage();
  const siteInstitucional = useRoutersSiteInstitucional();
  const sitePortfolio = useRoutersSitePortfolio();
  const sistemas = useRoutersSistemas();
  const lojas = useRoutersLojas();
  const marketing = useRoutersMarketing();

  return (
    <Routes>
      <Route index path="/" element={<Home />} />

      {landingPageRoutes.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      {siteInstitucional.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      {sitePortfolio.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      <Route key="/sites/manutencao-evolucao" path="/sites/manutencao-evolucao" element={<ManutencaoEvolucao />} />

      {sistemas.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      {lojas.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      {marketing.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      <Route
        path="/sobre-nos"
        element={
          <Suspense fallback={<LoadingPage />}>
            <SobreNos />
          </Suspense>
        }
      />
      <Route
        path="/termos-de-uso"
        element={
          <Suspense fallback={<LoadingPage />}>
            <TermosDeUso />
          </Suspense>
        }
      />
      <Route
        path="/politica-de-privacidade"
        element={
          <Suspense fallback={<LoadingPage />}>
            <PoliticaDePrivacidade />
          </Suspense>
        }
      />
      <Route
        path="/agendar"
        element={
          <Suspense fallback={<LoadingPage />}>
            <Agendar />
          </Suspense>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Router;
